import React from "react";
import { Button, Stack, Paper, Tooltip, useTheme } from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import HistoryIcon from "@mui/icons-material/History";
import PrintIcon from "@mui/icons-material/Print";

interface POSMiniTopBarShortcutsProps {
  onShortcut: (action: string) => void;
}

const shortcuts = [
  { label: "New Sale", action: "newSale", icon: <AddShoppingCartIcon />, tip: "Start a new sale" },
  { label: "Hold Order", action: "hold", icon: <PauseCircleIcon />, tip: "Put this order on hold" },
  { label: "Recall", action: "recall", icon: <HistoryIcon />, tip: "Recall a held order" },
  { label: "Print Last Receipt", action: "printLast", icon: <PrintIcon />, tip: "Print the last receipt" },
];

const POSMiniTopBarShortcuts: React.FC<POSMiniTopBarShortcutsProps> = ({ onShortcut }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={2}
      sx={{
        p: 1,
        mb: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        background: theme.palette.mode === "dark" ? "#23272e" : "#f5f6fa",
        borderRadius: 2,
        overflowX: "auto",
      }}
    >
      <Stack direction="row" spacing={2}>
        {shortcuts.map((s) => (
          <Tooltip title={s.tip} key={s.action} arrow>
            <Button
              variant="outlined"
              size="small"
              startIcon={s.icon}
              onClick={() => onShortcut(s.action)}
              sx={{
                color: theme.palette.mode === "dark" ? "white" : "inherit",
                borderColor: theme.palette.mode === "dark" ? "#666" : "inherit",
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  background: theme.palette.action.hover,
                },
              }}
            >
              {s.label}
            </Button>
          </Tooltip>
        ))}
      </Stack>
    </Paper>
  );
};

export default POSMiniTopBarShortcuts;
